import React, { Fragment } from "react"
import { connect } from 'react-redux'
import { noop, SUBROUTES_OBJ } from "utilities"
import { Drawer } from "components/Shell/Shell"
import Portal from 'components/Portal/Portal'
import { Modal, ConfirmDialog } from "components/Modal/Modal"
// import { Spinner } from "components/Loaders/Loaders"
import Ownership from "components/MyRecords/Ownership"
import AmendmentLauncher from "components/MyRecords/AmendmentLauncher"
import ReinstatementLauncher from "components/MyRecords/ReinstatementLauncher"
import { ConnectedRecordHistory } from "components/RecordHistory/RecordHistory"
import { history } from "../../store"
import ActionButton, {
  ActionButtonGroup
} from "components/ActionButton/ActionButton"
import DetailsList from "components/DetailsList/DetailsList"
import Pins from "components/MyRecords/Pins"
import RequestOwnership from "components/MyRecords/RequestOwnership"
import RequestCertificate from 'components/Certificates/RequestCertificate'
import SlidingPanel from 'components/SlidingPanel/SlidingPanel';
import Checkout from 'components/Checkout/Checkout';
import { calculateReceiptItemsTotal, calculateReceiptItemContainersTotal, getSourceTypeId } from 'utilities' 
import UserGroupIcon from '@tecuity/sos-icons/react/user-group'
import HistoryIcon from '@tecuity/sos-icons/react/history'
import CertificateIcon from '@tecuity/sos-icons/react/certificate'
import DocumentEditIcon from '@tecuity/sos-icons/react/document-edit'
import { LoginRedirectSwitch } from 'components/LoginRedirector/LoginRedirector'
import { setCartQuantity } from '../../actions'
import shortid from 'shortid'
import {
  GET_FILING_DETAILS,
  GET_AR_FORM_DEFINITION_ID,
  GET_AR_FORM_ACCESS_LEVEL,
  GET_REINSTATEMENT_FORM_DEFINITION_ID,
  GET_WEB_USER_IS_RECORD_OWNER,
  GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID,
  GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID,
  GET_NOTARY_RENEWAL_FORM_DEFINITION_ID,
  GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID,
  GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID,
  GET_CHARITABLE_AR_FORM_DEFINITION_ID,
  GET_RECORD_HAS_OWNERS,
  CREATE_CERTIFICATION,
  GET_WEB_CART_BY_CERTIFICATION_ID,
  GET_CERTIFICATION_CONFIG,
  GET_FARM_BILL_RECORD_DETAILS
} from "../../requests"

const SHOW_REQUEST_ACCESS_PUBLIC = process.env.SHOW_REQUEST_ACCESS_PUBLIC
const SHOPPING_CART = process.env.SHOPPING_CART

const ALLOW_CERTIFICATION_REQUEST =
  process.env.ALLOW_CERTIFICATION_REQUEST === undefined
    ? true
    : process.env.ALLOW_CERTIFICATION_REQUEST

const ALLOW_COPY_REQUEST =
  process.env.ALLOW_COPY_REQUEST === undefined
    ? true
    : process.env.ALLOW_COPY_REQUEST

const ALLOW_REINSTATEMENT_AR_MODAL =
  process.env.ALLOW_REINSTATEMENT_AR_MODAL === undefined
    ? true
    : process.env.ALLOW_REINSTATEMENT_AR_MODAL

const ALLOW_PUBLIC_CERTIFICATE_REQUEST = process.env.ALLOW_PUBLIC_CERTIFICATE_REQUEST
const PIN_SWAP_ON_SUCCESS = process.env.PIN_SWAP_ON_SUCCESS !== undefined ? process.env.PIN_SWAP_ON_SUCCESS : true;
const RD_TOOLTIP_AMENDMENT = process.env.RD_TOOLTIP_AMENDMENT;
const RD_TOOLTIP_REINSTATE = process.env.RD_TOOLTIP_REINSTATE;
const RD_TOOLTIP_CERTIFICATE = process.env.RD_TOOLTIP_CERTIFICATE;
const RD_TOOLTIP_HISTORY = process.env.RD_TOOLTIP_HISTORY;
const RD_TOOLTIP_USER_ACCESS = process.env.RD_TOOLTIP_USER_ACCESS;
const REQUIRE_ANNUAL_REPORT_CONFIRMATION = process.env.REQUIRE_ANNUAL_REPORT_CONFIRMATION;
const AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN = process.env.AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN
const ALLOW_CHECK_AR_ACCESS_LEVEL = process.env.ALLOW_CHECK_AR_ACCESS_LEVEL

const lobbyistRenewalLabel = (SUBROUTES_OBJ.lobbyist || {}).myRecordsRenewalButtonLabel

class RecordDrawer extends React.Component {
  state = {
    ownershipModalOpen: false,
    requestOwnershipModal: false,
    pinsModalOpen: false,
    amendmentLauncherOpen: false,
    reinstatementModalOpen: false,
    certificateModalOpen: false,
    userOwnsCurrentRecord: null,
    currentRecordHasOwners: null,
    certificateCheckoutOpen: false,
    loadingDetails: true,
    loadingOwnership: true,
    title: this.props.title,
    subtitle: this.props.subtitle,
    details: [],
    certificateReceiptItems: [],
    certificateReceiptItemContainers: [],
    certificateRefNum: null,
    certificateConfig: null,
    arConfirmOpen: false,
    arConfirmFunction: null,
    canAccessARLoggedIn: false,
    unavailableARMessage: null,
    unavailableReinstatementMessage: null,
    unavailableRenewalMessage: null
  }
  componentDidMount = () => {
    this.getUserOwnsRecord(this.props.category, this.props.sourceId)
    this.getRecordDetails(this.props.category, this.props.sourceId)
  }
  componentWillReceiveProps = nextProps => {
    if (
      this.props.sourceId !== nextProps.sourceId ||
      this.props.recordNum !== nextProps.recordNum ||
      this.props.category !== nextProps.category
    ) {
      this.getUserOwnsRecord(nextProps.category, nextProps.sourceId)
      if(nextProps.category === 'farm-bill' && process.env.USE_FARM_BILL_API){
        this.getFarmBillRecordDetails(nextProps.category, nextProps.uccDebtorID, nextProps.uccEfsProductID, nextProps.uccFilingID, nextProps.uccSecuredPartyID)
      }else{
        this.getRecordDetails(nextProps.category, nextProps.sourceId)
      }
      nextProps.loggedIn && nextProps.canFileAR && ALLOW_CHECK_AR_ACCESS_LEVEL && nextProps.recordNum && this.getARFormAccessLevel(nextProps.recordNum)
    }
    if (
      (this.props.title !== nextProps.title || this.props.subtitle !== nextProps.subtitle) &&
      (nextProps.title || nextProps.sourceId)
    ) {
      this.setState({ title: nextProps.title, subtitle: nextProps.subtitle })
    }
  }
  ANNUAL_REPORT_OPTIONS = () => {
    const { canReinstate, canFileAR } = this.props
    return {
      business: {
        label: this.state.arButtonLabel ? this.state.arButtonLabel :
        canReinstate
          ? "Reinstate"
          : canFileAR ? "File Annual Report" : "",
        tooltip: RD_TOOLTIP_AMENDMENT || RD_TOOLTIP_REINSTATE ? this.state.arButtonLabel ? this.state.arButtonLabel :
        canReinstate
          ? RD_TOOLTIP_REINSTATE
          : undefined : undefined,
        onClickFn : this.getWrappedAnualReportFunction(this.getReinstatementAROnClickFn())
      },
      contractor: {
        label: this.state.arButtonLabel || "File Contractor Renewal",
        onClickFn: this.getWrappedAnualReportFunction(this.openContractorRenewalWizard)
      },
      lobbyist: {
        label: this.state.arButtonLabel || lobbyistRenewalLabel || "File Lobbyist Renewal",
        onClickFn: this.getWrappedAnualReportFunction(this.openLobbyistRenewalWizard)
      },
      trademark: {
        label: this.state.arButtonLabel || "File Trademark Renewal",
        onClickFn: this.getWrappedAnualReportFunction(this.openTrademarkRenewalWizard)
      },
	    charitable: {
       label: this.state.arButtonLabel ? this.state.arButtonLabel :
        canReinstate
          ? "Reregister"
          : canFileAR ? "File Annual Report" : "",
        onClickFn: this.getWrappedAnualReportFunction(this.getCharitableReinstatementAROnClickFn())
      },
      notary: {
        label: this.state.arButtonLabel || "File Renewal",
        onClickFn: this.getWrappedAnualReportFunction(this.openNotaryRenewalWizard)
      },
    }
  }
   getCharitableReinstatementAROnClickFn = () => {
    const { canReinstate, canFileAR } = this.props
    if(ALLOW_REINSTATEMENT_AR_MODAL !== false) {
      if(canReinstate) {
        return this.openCharitableRenewalWizard
      } else if (canFileAR) {
        return this.openCharitableAnnualReportWizard
      } else {return noop}
    } else {
      if (canReinstate) {
        return this.openCharitableRenewalWizard
      } else if (canFileAR) {
        return this.openCharitableAnnualReportWizard
      } else {return noop}
    }
  }
  getReinstatementAROnClickFn = () => {
    const { canReinstate, canFileAR } = this.props
    if(ALLOW_REINSTATEMENT_AR_MODAL !== false) {
      if(canReinstate) {
        return this.toggleReinstatementModal;
      } else if (canFileAR) {
        return this.openAnnualReportWizard
      } else {return noop}
    } else {
      if (canReinstate) {
        return this.OpenReinstatementWizard
      } else if (canFileAR) {
        return this.openAnnualReportWizard
      } else {return noop}
    }
  }
  getWrappedAnualReportFunction = fn => () => {
    if(REQUIRE_ANNUAL_REPORT_CONFIRMATION){
      this.setState({arConfirmOpen: true, arConfirmFunction: fn})
    }else{
      fn()
    }
  }
  getRecordDetails = (category, sourceId) => {
    if (category && sourceId) {
      if(this.currentDetailsRequest){
        this.currentDetailsRequest.abort();
      }
      this.setState({ loadingDetails: true })

      GET_FILING_DETAILS(
        category,
        sourceId,
        false,
        signal => this.currentDetailsRequest = signal,
        data => {
          this.setState({
            details: data.DRAWER_DETAIL_LIST,
            arButtonLabel: data.AR_BUTTON_LABEL,
            loadingDetails: false,
            hideCertButton: data.HIDE_CERT_BUTTON,
            hideRequestAccess: data.HIDE_REQUEST_ACCESS,
            hideManageAccess: data.HIDE_MANAGE_ACCESS,
            hideHistory: data.HIDE_HISTORY,
            hideAmendmentButton: data.HIDE_AMENDMENT_BUTTON,
            alwaysShowAmendmentButton: data.ALWAYS_SHOW_AMENDMENT_BUTTON,
            certButtonRedirectsTo: data.CERT_BUTTON_REDIRECTS_TO,
            unavailableARMessage: data.UNAVAILABLE_AR_MESSAGE,
            unavailableReinstatementMessage: data.UNAVAILABLE_REINSTATEMENT_MESSAGE,
            unavailableRenewalMessage: data.UNAVAILABLE_RENEWAL_MESSAGE
          })
        },
        err => {
          if(err.name !== 'AbortError'){
            console.error(err)
          }
          this.setState({
            details: []
          })
        }
      )
    }
  }

  getFarmBillRecordDetails =(category, uccDebtorID, uccEfsProductID, uccFilingID, uccSecuredPartyID)=>{
    if (category && uccDebtorID && uccEfsProductID && uccFilingID && uccSecuredPartyID) {
      if(this.currentDetailsRequest){
        this.currentDetailsRequest.abort();
      }
      this.setState({ loadingDetails: true })
      const parameters = {
        UCC_EFS_PRODUCT_ID : uccEfsProductID
        , UCC_SECURED_PARTY_ID : uccSecuredPartyID
        , UCC_DEBTOR_ID : uccDebtorID
        , UCC_FILING_ID : uccFilingID
      }
    GET_FARM_BILL_RECORD_DETAILS(
      category,
      parameters,
      shortid.generate(),
      signal => this.currentDetailsRequest = signal,
      data => {
        this.setState({
          details: data.DRAWER_DETAIL_LIST,
          arButtonLabel: data.AR_BUTTON_LABEL,
          loadingDetails: false,
          hideCertButton: data.HIDE_CERT_BUTTON,
          hideRequestAccess: data.HIDE_REQUEST_ACCESS,
          hideManageAccess: data.HIDE_MANAGE_ACCESS,
          hideHistory: data.HIDE_HISTORY,
          hideAmendmentButton: data.HIDE_AMENDMENT_BUTTON,
          alwaysShowAmendmentButton: data.ALWAYS_SHOW_AMENDMENT_BUTTON,
          certButtonRedirectsTo: data.CERT_BUTTON_REDIRECTS_TO
        })
      },
      err => {
        if(err.name !== 'AbortError'){
          console.error(err)
        }
        this.setState({
          details: []
        })
      }
    )
  }
}
  getUserOwnsRecord = (category, sourceId) => {
    if(category && sourceId && !this.props.userOwnsCurrentRecord){
      this.setState({ loadingOwnership: true })
      GET_WEB_USER_IS_RECORD_OWNER(category, sourceId, userOwnsCurrentRecord => {
        if (userOwnsCurrentRecord) {
          this.setState({ userOwnsCurrentRecord, loadingOwnership: false })
        } else {
          GET_RECORD_HAS_OWNERS(category, sourceId, currentRecordHasOwners => {
            this.setState({
              userOwnsCurrentRecord,
              currentRecordHasOwners,
              loadingOwnership: false
            })
          })
        }
      })
    }
  }
  toggleOwnershipModal = () => {
      this.setState(state => ({ ownershipModalOpen: !state.ownershipModalOpen }))
  }
  toggleRequestOwnershipModal = () => {
    this.setState(state => ({
      requestOwnershipModal: !state.requestOwnershipModal
    }))
  }
  togglePinsModal = () => {
    if(this.state.pinsModalOpen){
      this.pinsModal.closeModal(() => {
        this.setState(state => ({ pinsModalOpen: false }))
      })
    }else{
      this.setState(state => ({ pinsModalOpen: true }))
    }
  }
  closeOwnershipModalAndRefreshRecords = () => {
    this.ownershipModal.closeModal()
    this.props.onRequestRecordsRefresh()
  }
  toggleAmendmentLauncher = () => {
    this.setState(state => ({
      amendmentLauncherOpen: !state.amendmentLauncherOpen
    }))
  }
  toggleReinstatementModal = () => {
    this.setState(state => ({
      reinstatementModalOpen: !state.reinstatementModalOpen
    }))
  }
  toggleCertificateModalOpen = () => {
    this.setState(state => ({
      certificateModalOpen: !state.certificateModalOpen
    }))
  }
  getConfigAndOpenCertificateModal = () => {
    if(this.props.sublink.certificateDownloadRedirectsTo){
      history.push(this.props.sublink.certificateDownloadRedirectsTo.replace(/{{recordNum}}/g, this.props.recordNum))
    }else if(this.state.certButtonRedirectsTo){
      history.push(this.state.certButtonRedirectsTo)
    }else{
      this.getCertificateConfig()
      .then(() => {
        this.setState({
          certificateModalOpen: true
        })
      })
    }
  }
  getCertificateConfig = () => (
    new Promise((resolve, reject) => {
      GET_CERTIFICATION_CONFIG(this.props.category, this.props.sourceId, certificateConfig => {
        this.setState({certificateConfig}, () => {resolve()})
      })
    })
  )
  swapRequestAndOwnershipModals = () => {
    this.setState({pinsModalOpen: false, ownershipModalOpen: PIN_SWAP_ON_SUCCESS ? true : false, userOwnsCurrentRecord: true})
  }
  openAnnualReportWizard = () => {
    const { recordNum } = this.props
    GET_AR_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
	OpenReinstatementWizard = () => {
    console.log("test")
    const { recordNum } = this.props
		GET_REINSTATEMENT_FORM_DEFINITION_ID(recordNum, formDefinitionId => {
      history.push(`/amend/${formDefinitionId}/${recordNum}`)
		}, console.error)
	}
	openCharitableRenewalWizard  = () => {
    const { recordNum } = this.props
    GET_CHARITABLE_RENEWAL_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  openCharitableAnnualReportWizard = () => {
    const { recordNum } = this.props
    GET_CHARITABLE_AR_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  openContractorRenewalWizard = () => {
    const { recordNum } = this.props
    GET_CONTRACTOR_RENEWAL_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  openLobbyistRenewalWizard = () => {
    const { recordNum } = this.props
    GET_LOBBYIST_RENEWAL_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  openTrademarkRenewalWizard = () => {
    const { recordNum } = this.props
    GET_TRADEMARK_RENEWAL_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  openNotaryRenewalWizard = () => {
    const { recordNum } = this.props
    GET_NOTARY_RENEWAL_FORM_DEFINITION_ID(recordNum, formDefId => {
      history.push(`/amend/${formDefId}/${recordNum}`)
    }, console.error)
  }
  toggleCertificateCheckout = () => {
    this.certificateModal.closeModal()
    this.setState(state => ({certificateCheckoutOpen: !state.certificateCheckoutOpen}))
  }
  cancelCertificateCheckout = () => {
    this.certificateSlider.closeSlider(() => {
      this.setState({certificateCheckoutOpen: false})
    })
  }
  createCertification = params => {
    // Get the FILING_ID of the selected filing
    var filingId = this.props.sourceId
    if (filingId) {
      CREATE_CERTIFICATION({
        FILING_ID: filingId,
        REQUESTOR_NAME: params.requesterName,
        EMAIL: params.email,
        CERTIFICATION_TYPE_ID: params.certType,
        CERTIFICATE_AMOUNT: params.certAmount,
        DELIVERY_METHOD: params.delivery,
        SOURCE_TYPE_ID: getSourceTypeId(this.props.category),
        ...params.address
      }, certificationId => {
        GET_WEB_CART_BY_CERTIFICATION_ID(certificationId, 
          SHOPPING_CART ? (cart) => {
          const total = calculateReceiptItemContainersTotal(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST)                  
          this.setState(
            {              
              certificateRefNum: cart.REF_NUM,
              certificateReceiptItemContainers: cart.RECEIPT_ITEM_CONTAINER_WEB_LIST,
            }, () => {
              if(total > 0){                
                setCartQuantity(cart.RECEIPT_ITEM_CONTAINER_WEB_LIST.filter((x) => !x.IS_FREE).length)                
                this.toggleCertificateCheckout();
              }else{
                this.redirectToReceipt()
              }
            }
          )
        } 
        :
        ({RECEIPT_ITEM_WEB_LIST, REF_NUM}) => {
          const total = calculateReceiptItemsTotal(RECEIPT_ITEM_WEB_LIST)
          this.setState(
            {
              certificateReceiptItems: RECEIPT_ITEM_WEB_LIST,
              certificateRefNum: REF_NUM
            }, () => {
              if(total > 0){
                this.toggleCertificateCheckout();
              }else{
                this.redirectToReceipt()
              }
            }
          )
        }
        , err => {
          this.certificateForm.setError()
          console.error(err)
        })
      }, console.error)
    }
  }
  redirectToReceipt = (refNum) => {
    history.push(`/receipt?ref=${refNum || this.state.certificateRefNum}`)
  }
  handleAccessRevoked = () => {
    this.setState({userOwnsCurrentRecord: false, userAccessRevoked: true})
    this.closeOwnershipModalAndRefreshRecords()
    this.getUserOwnsRecord()
  }
  getARFormAccessLevel = (recordNum) =>{
    GET_AR_FORM_ACCESS_LEVEL(recordNum, accessLevel => {
      if(accessLevel === 20 && process.env.ALLOW_SHOW_AR_WHEN_LOGGED_IN)
        this.setState({canAccessARLoggedIn:true})
      else
      this.setState({canAccessARLoggedIn:false})
    }, console.error)
  }
  render() {
    const {
      show,
      onSidebarDismiss,
      category = "business",
      sourceId,
      recordNum,
      canFileAR,
      canAlwaysFileAR,
      canReinstate,
      canFileReinstatement,
      loggedIn,
      showCopyRequests,
      sublink,
      userOwnsCurrentRecord,
      siteOffline,
      uccEfsProductID,
      uccSecuredPartyID,
      uccDebtorID,
      uccFilingID
    } = this.props
    const annualReportCategory = this.ANNUAL_REPORT_OPTIONS()[category] || {}
    const userOwnsRecord = (this.state.userOwnsCurrentRecord || userOwnsCurrentRecord)
    const disableARButton = this.state.unavailableARMessage || this.state.unavailableReinstatementMessage || this.state.unavailableRenewalMessage
    const arTooltipMessage = (this.state.unavailableARMessage ? this.state.unavailableARMessage :  
      this.state.unavailableReinstatementMessage ? 
      this.state.unavailableReinstatementMessage : this.state.unavailableRenewalMessage ? 
      this.state.unavailableRenewalMessage : annualReportCategory.tooltip)
    
    return (
      <Fragment>
        <Drawer
          show={show ? true : false}
          title={this.state.title}
          subtitle={this.state.subtitle}
          onSidebarDismiss={onSidebarDismiss}
          showCloseButton
          alwaysShowClosebutton
        >
          <div className={`${(this.state.loadingOwnership && !userOwnsCurrentRecord) || this.state.loadingDetails ? 'record-loading' : ''}`}>
            <ActionButtonGroup className="details-actions-top">
              {
                (this.state.alwaysShowAmendmentButton || ((AMENDMENTS_ALWAYS_ALLOWED_WHEN_LOGGED_IN && loggedIn) || (!this.state.hideAmendmentButton &&
                userOwnsRecord &&
                  (!this.state.loadingOwnership || userOwnsCurrentRecord)))) && (
                    <ActionButton
                      label={sublink.fileAmendmentButtonLabel || "File Amendment"}
                      children={<DocumentEditIcon/>}
                      onClick={this.toggleAmendmentLauncher}
                      tooltip={RD_TOOLTIP_AMENDMENT}
                    />
                  )
              }
              {(canAlwaysFileAR || this.state.canAccessARLoggedIn || ((canReinstate || canFileAR) && userOwnsRecord &&
                (!this.state.loadingOwnership || userOwnsCurrentRecord) &&
                (ALLOW_REINSTATEMENT_AR_MODAL || canFileAR))) && (
                  <ActionButton
                    label={annualReportCategory.label}
                    iconClass="icon icon-report"
                    onClick={annualReportCategory.onClickFn}
                    tooltip={arTooltipMessage}
                    disabled={disableARButton}
                  />
                )}
              {
                sublink.showRequestCertificate !== false
                && ((ALLOW_CERTIFICATION_REQUEST !== false
                  && userOwnsRecord
                  && (!this.state.loadingOwnership || userOwnsCurrentRecord)) || ALLOW_PUBLIC_CERTIFICATE_REQUEST
                )
                && this.state.hideCertButton !== true
                && !siteOffline
                && (
                  <ActionButton
                    label={sublink.requestCertificateAlternateLabel || "Request Certificate"}
                    children={<CertificateIcon/>}
                    onClick={this.getConfigAndOpenCertificateModal}
                    tooltip={RD_TOOLTIP_CERTIFICATE}
                  />
                )}
            </ActionButtonGroup>
            {(this.state.details || []).length > 0 && (
              <DetailsList details={this.state.details} />
            )}
            <ActionButtonGroup className="details-actions-bottom">
              {
                this.state.hideHistory ?
                null
                :
                <ConnectedRecordHistory
                  category={category}
                  amendmentNum={recordNum}
                  userOwnsRecord={userOwnsRecord}
                >
                  {({ openModal, loading }) => (
                    <ActionButton
                      label="View History"
                      onClick={openModal}
                      loading={loading}
                      disabled={this.state.loadingOwnership && !userOwnsCurrentRecord}
                      children={<HistoryIcon/>}
                      tooltip={RD_TOOLTIP_HISTORY}
                    />
                  )}
                </ConnectedRecordHistory>
              }
              {
                !siteOffline &&
                sublink.hideRecordUserManagment !== true ?
                loggedIn &&
                userOwnsRecord && !this.state.userAccessRevoked && !this.state.hideManageAccess ? (
                  <ActionButton
                    label="Manage User Access"
                    onClick={this.toggleOwnershipModal}
                    disabled={this.state.loadingOwnership && !userOwnsRecord}
                    children={<UserGroupIcon/>}
                    tooltip={RD_TOOLTIP_USER_ACCESS}
                  />
                ) : ((loggedIn || SHOW_REQUEST_ACCESS_PUBLIC) && this.state.currentRecordHasOwners) ? (
                  this.state.hideRequestAccess ?
                    null
                  :
                    <ActionButton
                      label="Request Access"
                      onClick={this.toggleRequestOwnershipModal}
                      disabled={this.state.loadingOwnership && !userOwnsRecord}
                      children={<UserGroupIcon/>}
                      tooltip={RD_TOOLTIP_USER_ACCESS}
                    />
                ) : (
                  (loggedIn || SHOW_REQUEST_ACCESS_PUBLIC) && !this.state.hideRequestAccess &&
                  <ActionButton
                    label="Request Access"
                    onClick={this.togglePinsModal}
                    disabled={this.state.loadingOwnership && !userOwnsRecord}
                    children={<UserGroupIcon/>}
                    tooltip={RD_TOOLTIP_USER_ACCESS}
                  />
                )
                : null
              }
			  {showCopyRequests && ALLOW_COPY_REQUEST && !siteOffline && (
              <ActionButton
                label="Copy Requests"
                iconClass="icon icon-download"
                onClick={null}
              />)}
            </ActionButtonGroup>
          </div>
          {/* <div className="loader-wrapper">
            <Spinner themeColor="medium-neutral" />
          </div> */}
        </Drawer>
        <Portal isOpened={this.state.ownershipModalOpen}>
          <Modal
            title="Manage User Access"
            closeModal={this.toggleOwnershipModal}
            modalSize="large"
            ref={ownershipModal => {
              this.ownershipModal = ownershipModal
            }}
            closeButton
          >
            <Ownership
              category={category}
              source_id={sourceId}
              onRequestModalClose={this.closeOwnershipModalAndRefreshRecords}
              onAccessRevoked={this.handleAccessRevoked}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.pinsModalOpen}>
          <Modal
            title="Request Access"
            closeModal={this.togglePinsModal}
            modalSize="short"
            hideHeader
            closeButton
            ref={ref => this.pinsModal = ref}
          >
            <Pins
              category={category}
              source_id={sourceId}
              onRequestModalClose={this.togglePinsModal}
              onPinSuccess={this.swapRequestAndOwnershipModals}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.requestOwnershipModal}>
          <Modal
            title="Request Ownership"
            closeModal={this.toggleRequestOwnershipModal}
            ref={requestOwnershipModal =>
              (this.requestOwnershipModal = requestOwnershipModal)
            }
            modalSize="short"
            hideHeader
            closeButton
          >
            {(loggedIn) ? 
            <RequestOwnership
              category={category}
              source_id={sourceId}
              onRequestModalClose={this.closeRequestOwnershipModal}
            />:<LoginRedirectSwitch location={location} />}
          </Modal>
        </Portal>
        <Portal isOpened={this.state.amendmentLauncherOpen}>
          <Modal
            title={sublink.fileAmendmentButtonLabel || "File Amendment"}
            closeModal={this.toggleAmendmentLauncher}
            ref={amendmentLauncher =>
              (this.amendmentLauncher = amendmentLauncher)
            }
            modalSize="small"
            closeButton
            // autoHeight
          >
            <AmendmentLauncher filingNum={recordNum} category={category} />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.reinstatementModalOpen}>
          <Modal
            title="Reinstate"
            closeModal={this.toggleReinstatementModal}
            ref={ref => (this.reinstatementModal = ref)}
            modalSize="small"
            closeButton
            autoHeight
          >
            <ReinstatementLauncher
              filingNum={recordNum}
              category={category}
              canFileAR={canFileAR}
              canFileReinstatement={canFileReinstatement}
              unavailableARMessage={this.state.unavailableARMessage}
			        unavailableReinstatementMessage={this.state.unavailableReinstatementMessage}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.certificateModalOpen}>
          <Modal
            title={sublink.requestCertificateAlternateLabel || "Request Certificate"}
            closeModal={this.toggleCertificateModalOpen}
            ref={ref => {this.certificateModal = ref}}
            modalSize="small"
            closeButton
            autoHeight
          >
            <RequestCertificate
              ref={r => {this.certificateForm = r}}
              config={this.state.certificateConfig}
              onCertificateRequested={this.createCertification}
              hideNameField={sublink.hideNameRequestCertificate}
              hideAddressBlock={sublink.hideAddressRequestCertificate}
            />
          </Modal>
        </Portal>
        <Portal isOpened={this.state.certificateCheckoutOpen}>
          <SlidingPanel
            closeOnShadeClick={false}
            closeSlider={this.cancelCertificateCheckout}
            ref={r=>{this.certificateSlider=r}}
            ariaLabel="Checkout"
          >
            <Checkout
            	cancelCheckout={this.cancelCertificateCheckout}
            	redirectToReceipt={this.redirectToReceipt}
            	amendmentNum={0}
            	formDefinitionId={0}
            	category={category}
            	correctionMode={false}
              receiptItems={this.state.certificateReceiptItems}
              receiptItemContainers={SHOPPING_CART ? this.state.certificateReceiptItemContainers : null}
              refNum={this.state.certificateRefNum}
            />
          </SlidingPanel>
        </Portal>
        <Portal isOpened={this.state.arConfirmOpen}>
          <ConfirmDialog
            closeModal={() => this.setState({arConfirmOpen: false})}
            sizeOverride="toast toast-wide"
            leftAligned
            onModalClosed={noop}
            message={<span>
              You are about to complete an online form for the record below.  Review the information to ensure this is the correct record:<br/><br/>
              <strong>Name</strong>: {this.state.title} <br/>
              <strong>SOS Control ID#</strong>: {recordNum}<br/>
              <strong>Record Type</strong>: {category === 'business' ? this.state.subtitle : sublink.label}<br/><br/>
              Is this the correct record for which you wish to complete the online form?

            </span>}
            buttons={[
              {
                label: 'Yes',
                onClick: this.state.arConfirmFunction,
                className: 'btn-primary'
              },
              { label: 'No', onClick: noop, className: 'btn-default' }
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </Fragment>
    )
  }
}
export default connect(
  state => ({
    loggedIn: state.auth.loggedIn,
    siteOffline: state.app.appSettings.WEBSITE_PORTAL_OFFLINE_YN === true,
    location: state.router.location
  })
)(RecordDrawer)



// WEBPACK FOOTER //
// ./src/components/RecordDrawer/RecordDrawer.js